import Main from '@/views/Main.vue';
import Reg from '@/views/register/reg.vue';

export const homeRouter = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/login/login.vue')
    },
    {
        path: '/contentupdate',
        name: 'contentupdate',
        component: Main,
        children:[
          {
            path: 'update',
            name: 'update',
            title: '内容修改',
            component: () => import('@/views/contentSuper/update.vue')
          }
        ]
    },
    {
      path: '/personinfo',
      name: 'personinfo',
      component: Main,
      children:[
        {
          path: 'verifystep/:mark',
          name: 'verifystep',
          title: '信息修改',
          component: () => import('@/views/accountSuper/verifyStep.vue')
        },
        {
          path: 'phone/phone',
          name: 'phone',
          title: '手机号修改',
          component: () => import('@/views/accountSuper/component/phone.vue')
        },
        {
          path: 'password/psd',
          name: 'password',
          title: '密码修改',
          component: () => import('@/views/accountSuper/component/password.vue')
        },
        {
          path: 'email/email',
          name: 'email',
          title: '邮箱修改',
          component: () => import('@/views/accountSuper/component/email.vue')
        },
        {
          path: 'success',
          name: 'success',
          title: '修改完成',
          component: () => import('@/views/accountSuper/success.vue')
        },
      ]
    },
  {
    path: '/register',
    name: 'register',
    component: Reg,
    children:[
      {
        path: 'index',
        name: 'index',
        title: '注册',
        component: () => import('@/views/register/index.vue')
      },
      {
        path: 'stepone/:type',
        name: 'stepone',
        title: '注册手机',
        component: () => import('@/views/register/stepOne.vue')
      },
      {
        path: 'company/:type',
        name: 'company',
        title: '企业注册',
        component: () => import('@/views/register/component/company.vue')
      },
      {
        path: 'instatute/:type',
        name: 'instatute',
        title: '机构注册',
        component: () => import('@/views/register/component/instatute.vue')
      },
      {
        path: 'other/:type',
        name: 'other',
        title: '其他注册',
        component: () => import('@/views/register/component/other.vue')
      },
      {
        path: 'steplast/:type',
        name: 'steplast',
        title: '信息核对',
        component: () => import('@/views/register/stepLast.vue')
      }
    ]
  },
];

export const appRouter = [
    {
        path: '/contentsuper',
        name: 'contentsuper',
        icon: 'folder',
        title: '内容管理',
        component: Main,
        children:[
            {
                path: 'content',
                icon: 'paperclip',
                name: 'content',
                title: '内容管理',
                component: () => import('@/views/contentSuper/content.vue')
            }
        ]
    },
    {
        path: '/organizesuper',
        name: 'organizesuper',
        icon: 'folder',
        title: '组织管理',
        component: Main,
        children:[
            {
                path: 'member',
                icon: 'paperclip',
                name: 'member',
                title: '组织管理',
                component: () => import('@/views/organizeSuper/member.vue')
            }
        ]
    },
    {
        path: '/usersuper',
        name: 'usersuper',
        icon: 'folder',
        title: '用户管理',
        component: Main,
        children:[
            {
                path: 'user',
                icon: 'paperclip',
                name: 'user',
                title: '用户管理',
                component: () => import('@/views/userSuper/user.vue')
            }
        ]
    },
    {
        path: '/goodssuper',
        name: 'goodssuper',
        icon: 'folder',
        title: '商品管理',
        component: Main,
        children:[
            {
                path: 'goods',
                icon: 'paperclip',
                name: 'goods',
                title: '商品管理',
                component: () => import('@/views/goodsSuper/goods.vue')
            },
            {
                path: 'attrbute',
                icon: 'paperclip',
                name: 'attrbute',
                title: '属性管理',
                component: () => import('@/views/goodsSuper/attrbute.vue')
            },
            {
                path: 'category',
                icon: 'paperclip',
                name: 'category',
                title: '类目管理',
                component: () => import('@/views/goodsSuper/category.vue')
            },
            {
                path: 'brand',
                icon: 'paperclip',
                name: 'brand',
                title: '品牌管理',
                component: () => import('@/views/goodsSuper/brand.vue')
            }
        ]
    },
    {
      path: '/accountsuper',
      name: 'accountsuper',
      icon: 'folder',
      title: '账号管理',
      component: Main,
      children:[
        {
          path: 'security',
          icon: 'paperclip',
          name: 'security',
          title: '账户安全',
          component: () => import('@/views/accountSuper/security.vue')
        },
        {
          path: 'service',
          icon: 'paperclip',
          name: 'service',
          title: '客服',
          component: () => import('@/views/accountSuper/service.vue')
        }
      ]
    }
];

export const AllRouter =  [...homeRouter,...appRouter];




// WEBPACK FOOTER //
// ./src/router/router.js